var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1895 0 0 11.1895 0 25C0 38.8105 11.1895 50 25 50C38.8105 50 50 38.8105 50 25C50 11.1895 38.8105 0 25 0ZM25 9.67742C29.8992 9.67742 33.871 13.6492 33.871 18.5484C33.871 23.4476 29.8992 27.4194 25 27.4194C20.1008 27.4194 16.129 23.4476 16.129 18.5484C16.129 13.6492 20.1008 9.67742 25 9.67742ZM25 44.3548C19.0827 44.3548 13.7802 41.6734 10.2319 37.4798C12.127 33.9113 15.8367 31.4516 20.1613 31.4516C20.4032 31.4516 20.6452 31.4919 20.877 31.5625C22.1875 31.9859 23.5585 32.2581 25 32.2581C26.4415 32.2581 27.8226 31.9859 29.123 31.5625C29.3548 31.4919 29.5968 31.4516 29.8387 31.4516C34.1633 31.4516 37.873 33.9113 39.7682 37.4798C36.2198 41.6734 30.9173 44.3548 25 44.3548Z",
    fill: "#61738E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.77647b86fc800ccfb4b33a7f0bbb0e01.svg";
export { ForwardRef as ReactComponent };